"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTitleWithBreadcrumbs = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
function getTitleWithBreadcrumbs(insightTitle, breadcrumbs) {
    var separator = "\u203A";
    var paddedSeparator = " " + separator + " ";
    return compact_1.default(tslib_1.__spread([insightTitle], breadcrumbs)).join(paddedSeparator);
}
exports.getTitleWithBreadcrumbs = getTitleWithBreadcrumbs;
//# sourceMappingURL=getTitleWithBreadcrumbs.js.map